export default __webpack_public_path__ + "32647bcda03eaffe4ee531f7a522de4c.png";